import React, { ChangeEvent, FormEvent, useEffect, useState } from "react";
import { connect, useSelector } from "react-redux";
import { CreateEpisodeForm } from "modules/video/components/CreateFolderForm";
import { createVideoEpisode } from "../store/action";
import {
  CreateEpisodeError,
  EpisodeInput,
} from "modules/video/components/DataType";
import { CreateEpisodeInput } from "../store/actionType";
import { VideoSeasonProps } from "modules/video/season/store/actionType";
import { ApiError } from "components";

interface CreateEpisodeProps {
  seasonData: VideoSeasonProps;
  isModalOpen: boolean;
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CreateEpisodeProps;

const CreateEpisode: React.FC<Props> = ({
  closeModal,
  seasonData,
  onCreateVideoEpisode,
}) => {
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState<EpisodeInput>({
    label: "",
    episode_number: 0,
  });
  const [error, setError] = useState<CreateEpisodeError>({});
  const [apiError, setApiError] = useState(null);
  const videoEpisodeState = useSelector(
    (state: any) => state.videoEpisodes?.genericVideoEpisodeState
  );

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "number" ? Number(value) : value,
    }));
    setError((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const handleSave = async (e: FormEvent) => {
    e.preventDefault();
    var input: CreateEpisodeInput = {
      label: formData.label,
      episode_number: formData.episode_number,
      season_folder_id: seasonData?.folder_id,
      season_id: seasonData?.id,
    };
    if (formData.label.trim() === "") {
      setError((prevErrors) => ({
        ...prevErrors,
        title: "Episode label is required",
      }));
    }
    if (formData.episode_number === 0) {
      setError((prevErrors) => ({
        ...prevErrors,
        order: "Episode number is required",
      }));
    }
    if (formData.label.trim() !== "" && formData.episode_number !== null) {
      setLoading(true);
      onCreateVideoEpisode(input);
      setSubmitted(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!videoEpisodeState.isLoading && submitted) {
      if (videoEpisodeState.error) {
        setApiError(videoEpisodeState.error); // show error
      } else {
        setApiError(null);
        closeModal(false);
      }
    }
  }, [videoEpisodeState.isLoading, videoEpisodeState.error, submitted, closeModal]);
  return (
    <>
      <CreateEpisodeForm
        handleChange={handleChange}
        handleSubmit={handleSave}
        formData={formData}
        formErrors={error}
        loading={loading}
        header={"Create Episode"}
      />
      {apiError && <ApiError>{apiError}</ApiError>}
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onCreateVideoEpisode: (input: CreateEpisodeInput) =>
    dispatch(createVideoEpisode(input)),
});

export default connect(null, mapDispatchToProps)(CreateEpisode);
